import React from 'react';
import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

const StyledContentLoader = styled(ContentLoader)`
  height: 272px;
  margin-bottom: var(--size-8);
  width: 242px;
`;

const GratitudeBoardItem = props => (
  <StyledContentLoader {...props} viewBox="0 0 242 272">
    <rect x="0" y="0" rx="6" ry="6" width="100%" height="100%" />
  </StyledContentLoader>
);

export default GratitudeBoardItem;
